import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/services/LoggingService';

export async function fetchPortfoliosForUser(userId: string, portfolioType?: string) {
  const queryOptions: Record<string, any> = { user_id: userId };
  if (portfolioType) queryOptions.portfolio_type = portfolioType;

  const { data, error } = await supabase
    .from('portfolios')
    .select('*')
    .match(queryOptions)
    .order('created_at', { ascending: false });

  if (error) {
    logger.error('PortfoliosService', 'fetchPortfoliosForUser failed', { error, userId, portfolioType });
    throw error;
  }

  return data || [];
}
